class LoginController {

    constructor (_, state, initConfigProvider, securityService, $rootScope, helperService) {
        this.state = state;
        this.loading = false;
        this.errors = null;
        this.username = null;
        this.password = null;
        this.targetId = null;
        this.environment = initConfigProvider.environment;
        this.securityService = securityService;
        this.rootScope = $rootScope;
        this._ = _;
        this.helperService = helperService;
    }
    
    login () {
        this.securityService.authenticate(this.username, this.password, this.targetId)
            .then((response) => this._actOnResponse(response));
    }
    
    _actOnResponse = (response) => {
        if (response.autheticated) {
            if(this.rootScope.returnUrl){
                let urlMatch = this.helperService.getMatchingStateByUrl(this.rootScope.urlMatcherForStates, this.rootScope.returnUrl);
                if (urlMatch) {
                    this.state.go(urlMatch.state.name, urlMatch.match);
                    return;
                }

            }
            this.state.go("/.coi.home");
            return;
        }
        this.errors = [response.error];
        return;
    }
}

    LoginController.$inject = ['_', '$state', 'initConfigProvider', 'securityService', '$rootScope', 'helperService'];

export default LoginController;



// WEBPACK FOOTER //
// ./app/login/login.controller.js